import { BrandLogo } from '@calendly/ui/components/brand-logo';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { logoName } from '../config';
const emailAddressCondensedCss = "edl7msf";
const EmailAddressCondensed = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(emailAddressCondensedCss, props.className)} />;
});
const styledLogoCss = "syag6gv";
const StyledLogo = forwardRef((props, ref) => <BrandLogo ref={ref} {...props} className={classNames(styledLogoCss, props.className)} />);
export const SendFromOption = options => <>
    <StyledLogo name={logoName[options.type]} />
    <EmailAddressCondensed>{options.emailAddress}</EmailAddressCondensed>
  </>;

require("./send_from_option.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./send_from_option.js");